import { type NextRequest, NextResponse } from 'next/server';
import { loggerFactory } from '@repo/logger';

export const WORDPRESS_ACTIVE_SESSION_PREFIX = 'wordpress_logged_in_';
export const WORDPRESS_ACTIVE_SESSION_COOKIE = 'wordpress_session_active';

export const setIsWpLoggedInCookie = (request: NextRequest, response: NextResponse): void => {
  const hasActiveWPSession = request.cookies.getAll().some(cookie => {
    return cookie.name.startsWith(WORDPRESS_ACTIVE_SESSION_PREFIX);
  });

  if (hasActiveWPSession) {
    response.cookies.set(WORDPRESS_ACTIVE_SESSION_COOKIE, '1');
  }
};

export const rewriteWordpressPreviews = (request: NextRequest): NextResponse => {
  const logger = loggerFactory({
    component: 'rewriteWordpressPreviews',
    path: `/src/lib/middleware/wordpress`,
  });
  logger.trace('ENTER: Wordpress preview check.');

  const url = new URL(request.url);
  const pathname = url.pathname;
  const rewriteUrl = new URL(`${pathname}/draft`, request.url);
  rewriteUrl.search = url.search;

  logger.info({ rewriteUrl }, 'Wordpress preview found.');

  return NextResponse.rewrite(rewriteUrl);
};
